// frontend/src/config/PlatformDetails.js
export const PLATFORM_DETAILS = {
  title: "Platform Coverage Details",
  description: "Explore the educational boards and subjects currently supported by our platform.",
  coverage: [
    {
      board: "CBSE",
      subject: "Mathematics",
      years: ["Coming"]
    },
    {
      board: "ICSE",
      subject: "Mathematics",
      years: ["Coming"]
    },
    {
      board: "IGCSE",
      subject: "Mathematics",
      years: ["Coming"]
    },
    {
      board: "Singapore",
      subject: "Mathematics",
      years: ["Coming"]
    },
    {
      board: "Australia",
      subject: "Mathematics",
      years: ["Year 5", "Year 6"]
    }
  ],
  note: "We are continuously expanding our curriculum to include more boards and subjects. Stay tuned for updates!",
  last_updated: () => {
    const now = new Date();
    const month = now.toLocaleString('en-US', { month: 'long' });
    const year = now.getFullYear();
    return `${month} ${year}`;
  }
};
